import { toast } from "mdbreact";
import axios from "axios";
import { v4 as uuid } from "uuid";
import {
  callApiV2,
  getOptions,
  setGTMEvent,
  getCurrentStore,
  showError,
  getDefValues,
  getCookie,
  getLoginInfo,
  getCurrency,
  validDiscount,
  toFixed,
  calculateDiscount,
  validateCart,
  showMessage,
  getSyncStoresInfo,
} from "./functions";

const discountTemplate = [];
const privateFolder = process.env.REACT_APP_FOLDER_LAYOUT;

export function updateQuantityByStoreId(data, storeId) {
  return data.map((item) => {
    //console.log("check data", item.storequantities, storeId)
    const store = item.storequantities.find(
      (sq) => String(sq.storeid) === String(storeId)
    );
    return {
      ...item,
      quantity: store ? store.quantity : 0, // set to 0 if not found
    };
  });
}

export function updateOptionsSizes(
  storeId,
  selectedColor,
  selectedSize,
  storequantities,
  options,
  sizes = new Set()
) {
  let alreadyChanged = false;
  const newOptions = JSON.parse(JSON.stringify(options));
  let newColor = selectedColor;
  let newSize = selectedSize;
  let sku = {};
  let objStrQty = {};
  // Cuando no hay stock del par actual
  sku = storequantities.find(
    (q) =>
      q.color.trim() === newColor.trim() &&
      q.size.trim() === newSize.trim() &&
      q.storeid === storeId
  );
  const quantity = sku?.quantity ?? 0;

  if (quantity === 0) {
    // Marcar la opción seleccionada como banned
    const selectedOption = newOptions[1].optionvalues.find(
      (q) => q.value === newSize
    );
    if (selectedOption) selectedOption.banned = true;

    if (sizes?.size > 0) {
      for (const size of sizes) {
        if (size === newSize) continue;

        objStrQty = storequantities.find(
          (q) =>
            q.color === newColor && q.size === size && q.storeid === storeId
        );
        const altQuantity = objStrQty?.quantity ?? 0;
        if (altQuantity > 0 && !alreadyChanged) {
          newOptions[1].optionvalues.find(
            (q) => q.value === size
          ).banned = false;
          newSize = size;
          alreadyChanged = true;
          sku = objStrQty;
        } else if (altQuantity === 0) {
          const option = newOptions[1].optionvalues.find(
            (q) => q.value === size
          );
          if (option) option.banned = true;
        }
      }
    }
  }

  return { newOptions, newColor, newSize, sku };
}

export function updateOptionsAll(
  storeId,
  selectedColor,
  selectedSize,
  storequantities,
  options,
  sizes = new Set(),
  colors = new Set()
) {
  let alreadyChanged = false;
  const newOptions = JSON.parse(JSON.stringify(options));
  let newColor = selectedColor;
  let newSize = selectedSize;
  let updateSize = false;
  let updateColor = false;
  let objStrQty = {};
  let sku = storequantities.find(
    (q) =>
      q.color.trim() === selectedColor.trim() &&
      q.size.trim() === selectedSize.trim() &&
      q.storeid === storeId
  );
  if (sizes?.size > 0) {
    for (const size of sizes) {
      objStrQty = storequantities.find(
        (q) =>
          q.color.trim() === newColor.trim() &&
          q.size.trim() === size.trim() &&
          Number(q.storeid) === Number(storeId)
      );
      const altQuantity = objStrQty?.quantity ?? 0;

      if (altQuantity > 0) {
        newOptions[1].optionvalues.find((q) => q.value === size).banned = false;
        if (updateSize && !alreadyChanged) {
          newSize = size;
          sku = objStrQty;
        }
        alreadyChanged = true;
      } else if (altQuantity === 0) {
        const option = newOptions[1].optionvalues.find((q) => q.value === size);
        if (option) {
          updateSize = true;
          option.banned = true;
        }
      }
    }
  } else if (colors?.size > 0) {
    for (const color of colors) {
      objStrQty = storequantities.find(
        (q) =>
          q.color.trim() === color.trim() &&
          q.size.trim() === newSize.trim() &&
          q.storeid === storeId
      );
      const altQuantity = objStrQty?.quantity ?? 0;
      if (altQuantity > 0) {
        newOptions[0].optionvalues.find(
          (q) => q.value === color
        ).banned = false;
        if (updateColor && !alreadyChanged) {
          newColor = color;
        }
        alreadyChanged = true;
      } else if (altQuantity === 0) {
        const option = newOptions[0].optionvalues.find(
          (q) => q.value === color
        );
        if (option) option.banned = true;
      }
    }
  }
  return { newOptions, newColor, newSize, sku };
}

export function findValueByIdV2(_json, _value, _key, _param) {
  const found = _json.find((item) => item[_key] === _value);
  return found ? found[_param] : "NOT FOUND";
}


export async function addEventCartV2(_product, _quantity) {
  try {
    if (!_product.productsku) {
      showError(toast, getDefValues().invalidSKU);
      return null;
    } else {
      var isValid = true;
      if (isValid) {
        let { productid, sku } = parseProductId(_product.productid);
        var eventId = getCookie(process.env.REACT_APP_ORG_NAME + "_eventId");
        var _optionsselected = _product.optionsselected;
        var optionsselected = [];
        let res = await getOptions();
        let options = res.rows;
        var skus;
        if (_product.skus.length > 0) {
          skus = _product.skus;
        }
        for (let o in _optionsselected) {
          let label = _optionsselected[o].optionLabel;
          let showOption = false;
          if (!_optionsselected[o].optionLabel) {
            label = findValueByIdV2(
              options,
              _optionsselected[o].optionid,
              "optionid",
              "optionname"
            );
          }

          let _optionvalues = findValueByIdV2(
            _product.options,
            _optionsselected[o].optionid,
            "optionid",
            "optionvalues"
          );
          if (_optionvalues.length > 1) {
            showOption = true;
          }
          if (showOption) {
            var val = findValueByIdV2(
              _product.quantities,
              _optionsselected[o].optionvalue,
              "optionvalue",
              "optioncustomer"
            );
            optionsselected.push({
              optionLabel: label,
              optionid: _optionsselected[o].optionid,
              optionvalue: val !== "NOT FOUND" ? val : null,
            });
          }
        }
        let formData = {
          sku: _product.productsku,
          productid: productid,
          eventid: String(eventId),
          quantity: _quantity,
        };
        let resp = await callApiV2(
          "frontend",
          "setProductEvent",
          formData
        );
        console.log(resp)

        if (resp.success) {
          showMessage(
            toast,
            getDefValues().successfullyAddedToEventListLabel
          );
        } else {
          showError(
            toast,
            getDefValues().errorAddedToEventListLabel
          );
        }


      }
    }
  } catch (Excep) {
    console.log("Ex", Excep);
    showError(toast, "SHOPCART Excep:" + Excep);
    return null;
  }
}

function normalizeLabel(value) {
  if (!value) return value;

  let result = value;

  // Solo normalizar si parece archivo (con extensión)
  if (/\.[a-zA-Z]+$/.test(value)) {
    result = value
      .split("/")
      .pop()                  // nombre archivo
      .replace(/\.[^.]+$/, "") // quita extensión
      .replace(/_\d+$/, "")    // quita _1, _2...
      .replace(/_/g, " ")      // _ → espacio
      .trim();
  }

  // Primera letra en mayúscula
  return result.charAt(0).toUpperCase() + result.slice(1);
}


export async function addShopCartV2(_product, _IncData, _quantity) {
  try {
    if (process.env.REACT_APP_URL_CONFIG === "http://localhost:8082") {
      console.log("_IncData,", _IncData)
      console.log("_product", _product)
    }
    let data = _IncData
    const action = getCookie(process.env.REACT_APP_ORG_NAME + "_action");

    if (action === "addEventCart") {
      const eventId = getCookie(process.env.REACT_APP_ORG_NAME + "_eventId");
      console.log("es evento")
      _product.eventid = eventId
    }
    if (!data) {
      console.log("Fixing cart")
      try {
        data = JSON.parse(
          localStorage.getItem(process.env.REACT_APP_ORG_NAME + "_activeCartV3")
        );
      } catch (ex) {
        console.log("NO CART CREATING:")
        data = {
          id: uuid(),
          products: []
        }
        localStorage.setItem(
          process.env.REACT_APP_ORG_NAME + "_activeCartV3",
          JSON.stringify(data)
        );
      }
      console.log("data", data)
      if (!data) {
        data = {
          id: uuid(),
          products: []
        }
        localStorage.setItem(
          process.env.REACT_APP_ORG_NAME + "_activeCartV3",
          JSON.stringify(data)
        );
      }
    }

    if (!_product.productsku) {
      showError(toast, getDefValues().invalidSKU);
      return null;
    } else {

      if (!_product.productsku && _product.sku) {
        _product.productsku = _product.sku
      }
      var limitExceeded = false;
      var isValid = true;

      let maxQuantity = _product.maxQuantity


      const q = _product.quantities.find(
        item => String(item.sku) === _product.productsku
      );

      if (!q) {
        showError(toast, getDefValues().invalidSKU);
        return null;
      }
      maxQuantity = q.quantity
      //console.log("maxQuantity",maxQuantity)

      if (_product.eventid) {
        try {
          for (let a in data.products) {
            if (data.products[a].eventid) {
              if (data.products[a].eventid !== _product.eventid) {
                //console.log("error event dup")
                isValid = false;
                showError(toast, getDefValues().duplicatedEventError);
              }
            }
          }
        } catch (exc) {
          isValid = false;
          console.log("exc", exc);
          showError(toast, getDefValues().errorGettingCartProducts);
        }
      }

      if (isValid) {
        let { productid, sku } = parseProductId(_product.productid);

        //console.log(".", _product, productid, _quantity);

        var objProduct = {
          id: productid,
          price: _product.priceold,
          name: _product.label,
          category: _product.category ? _product.category : "-",
          brand: "",
          quantity: 1,
          store: getCurrentStore(),
          variant: _product.sku,
          skus: _product.skus,
        };
        setGTMEvent("addToCart", objProduct);
        var _optionsselected = _product.optionsselected;

        var optionsselected = [];
        let res = await getOptions();
        let options = res.rows;
        //console.log("options::::", options)
        var skus;
        if (_product.skus.length > 0) {
          skus = _product.skus;
        }
        for (let o in _optionsselected) {
          let label = _optionsselected[o].optionLabel;
          let showOption = false;
          if (!_optionsselected[o].optionLabel) {
            label = findValueByIdV2(
              options,
              _optionsselected[o].optionid,
              "optionid",
              "optionname"
            );
          }

          let _optionvalues = findValueByIdV2(
            _product.options,
            _optionsselected[o].optionid,
            "optionid",
            "optionvalues"
          );
          if (_optionvalues.length > 1) {
            showOption = true;
          }
          if (showOption) {
            let val = normalizeLabel(_optionsselected[o].optionvalue ?? "")
            if (_optionsselected[o].sku !== _product.productsku) {
              //console.log("fixing options", _product.quantities, _product.productsku)
              let skuObj = _product.quantities.find(
                (s) =>
                  String(s.sku) === String(_product.productsku)
              )
              if (skuObj.optionid) {
                //console.log("Fixing optionid!!!")
                skuObj = _product.quantities.find(
                  (s) =>
                    String(s.sku) === String(_product.productsku) && Number(_optionsselected[o].optionid) === Number(s.optionid)
                )
              }
              //console.log("skuObj:", skuObj)
              if (Number(_optionsselected[o].optionid) === 9) {
                val = skuObj.size
              } else {
                val = normalizeLabel(skuObj.color ?? skuObj.optionvalue)
              }
            }
            optionsselected.push({
              optionLabel: label,
              optionid: _optionsselected[o].optionid,
              optionvalue: val,
            });
          }
        }

        var price = parseFloat(_product.priceold);
        var priceOld = false;

        var NEWPRICED = null;
        var NEWPRICEC1 = null;
        var NEWPRICEC2 = null;

        var curProducts = data.products;
        var id = data.id;

        let position = curProducts.findIndex(
          (item) => item.productsku === _product.productsku
        );

        var master = null;
        var combos = [];
        var combosTotal = [];
        var subtotal = 0;
        //console.log("position", position);
        if (position < 0) {
          let quantity = parseFloat(_quantity);
          if (
            maxQuantity >=
            parseFloat(_quantity)
          ) {
            let Cproduct = validDiscount(_product, quantity);
            if (Cproduct.discount) {
              subtotal = Cproduct.subtotal;
              priceOld = Cproduct.discountM;
              NEWPRICED = Cproduct.discount;
            }
            let combo_name
            if (Cproduct.isCombo) {
              let respC = await callApiV2("customer", "getActiveCombos", {
                skus: null,
                combo_name: Cproduct.combo_name,
              });

              for (let k in respC.template) {
                let key = respC.template[k];
                discountTemplate.push(key);
                if (
                  key.sku.toString() === _product.productsku.toString() ||
                  master === key.productid + "__" + key.name
                ) {
                  if (key.newpricec1) {
                    master = key.productid + "__" + key.name;
                    combos.push(key);
                  }
                }
                if (key.newpricec1) {
                  combo_name = key.combo_name
                  combosTotal.push(key);
                }
              }
            }

            //console.log("adddin!!!!", quantity);
            curProducts.push({
              productsku: _product.productsku,
              prequantity: null,
              optionsselected: optionsselected,
              productid: productid,
              quantity: quantity,
              price: price,
              priceOld: priceOld,
              subtotal: subtotal,
              NEWPRICED: NEWPRICED,
              NEWPRICEC1: NEWPRICEC1,
              NEWPRICEC2: NEWPRICEC2,
              combo_name: combo_name,
              category: _product.category,
              productpath: _product.productpath,
              maxQuantity: maxQuantity,
              image: _product.path,
              productname: _product.label,
              skus: skus,
              eventid: _product.eventid,
            });
            position = curProducts.length - 1;
          } else {
            limitExceeded = true;
            showError(toast, getDefValues().limitedExceeded);
          }
        } else {
          //console.log("else")
          let curQuantity = curProducts[position].quantity;
          let quantity = parseFloat(_quantity) + parseFloat(curQuantity);
          let subtotal = quantity * price;

          //console.log("Qty", maxQuantity, _quantity, curQuantity)
          if (
            maxQuantity >=
            parseFloat(_quantity) + parseFloat(curQuantity)
          ) {
            let Cproduct = validDiscount(_product, quantity);
            if (Cproduct.discount) {
              subtotal = Cproduct.subtotal;
              priceOld = Cproduct.discountM;
              NEWPRICED = Cproduct.discount;
            }

            //console.log("Cproduct U", Cproduct);

            let combo_name

            if (Cproduct.isCombo) {
              let respC = await callApiV2("customer", "getActiveCombos", {
                skus: null,
                combo_name: Cproduct.combo_name,
              });
              //console.log("respC", respC);
              for (let k in respC.template) {
                let key = respC.template[k];
                discountTemplate.push(key);
                if (
                  key.sku.toString() === _product.productsku.toString() ||
                  master === key.productid + "__" + key.name
                ) {
                  if (key.newpricec1) {
                    master = key.productid + "__" + key.name;
                    combos.push(key);
                  }
                }
                if (key.newpricec1) {
                  combo_name = key.combo_name
                  combosTotal.push(key);
                }
              }
            }
            curProducts[position] = {
              productsku: _product.productsku,
              prequantity: null,
              optionsselected: optionsselected,
              productid: productid,
              quantity: parseFloat(_quantity) + parseFloat(curQuantity),
              subtotal: subtotal,
              NEWPRICED: NEWPRICED,
              NEWPRICEC1: NEWPRICEC1,
              NEWPRICEC2: NEWPRICEC2,
              combo_name: combo_name,
              category: _product.category,
              productpath: _product.productpath,
              maxQuantity: maxQuantity,
              price: price,
              priceOld: priceOld,
              image: _product.path,
              productname: _product.label,
              skus: skus,
              eventid: _product.eventid,
            };
          } else {
            limitExceeded = true;
            showError(toast, getDefValues().limitedExceeded);
          }
        }

        var Fsubtotal = 0;
        var total = 0;
        var skuT = 0;
        //let key = curProducts[position];

        if (combos.length > 0) {
          for (let k2 in curProducts) {
            let pos = combosTotal.findIndex(
              (item) => item.sku === curProducts[k2].productsku
            );
            //console.log("TTT", combosTotal[pos])
            if (pos >= 0) {
              skuT = skuT + curProducts[k2].quantity;
              /*curProducts[k2]["combo_name"] =
                //combosTotal[pos].productid + 
                 "__" + combosTotal[pos].combo_name;*/
              curProducts[k2]["NEWPRICEC1"] = combosTotal[pos].newpricec1;
              curProducts[k2]["NEWPRICEC2"] = combosTotal[pos].newpricec2;
              curProducts[k2]["priceOld"] =
                parseInt(combosTotal[pos].newpricec1) +
                "x" +
                getCurrency() +
                toFixed(
                  combosTotal[pos].newpricec2 * combosTotal[pos].newpricec1
                );
            }
          }
        }
        for (let k in curProducts) {
          let key = curProducts[k];
          var totalSKUs = 0;
          //console.log("REV", key, key.combo_name)
          if (key.combo_name) {
            var combo_name = key.combo_name;
            for (let k2 in curProducts) {
              var key2 = curProducts[k2];
              if (combo_name === key2.combo_name) {
                totalSKUs = totalSKUs + key2.quantity;
              }
            }
            if (totalSKUs < curProducts[k]["NEWPRICEC1"]) {
              //console.log("DELETE!!!!!!!!!!")
              delete key.NEWPRICEC1;
              delete key.NEWPRICEC2;
            } else {
              key["totalSKUs"] = totalSKUs;
            }
          }
        }
        for (let k in curProducts) {
          let key = curProducts[k];
          Fsubtotal =
            Fsubtotal + parseFloat(key.price) * parseFloat(key.quantity);
        }
        var discount = calculateDiscount(curProducts);
        total = Fsubtotal - discount;


        for (let k in curProducts) {
          let key = curProducts[k];
          //delete key.combo_name
          delete key.totalSKUs
          delete key.showUpdate
        }

        data = {
          id: id,
          userID: getLoginInfo().userId,
          discount: toFixed(discount),
          needCommit: false,
          products: curProducts,
          subtotal: toFixed(Fsubtotal),
          total: toFixed(total),
        };

        var respCart = validateCart(data);
        //console.log("respCart", respCart)
        console.log("respCart", data, respCart);
        if (respCart.success) {
          if (!limitExceeded) {
            /* localStorage.setItem(
              process.env.REACT_APP_ORG_NAME + "_activeCartV3",
              JSON.stringify(data)
            );
            */
            //setShopCart(data);
            //data = _IncData;
            
            showMessage(toast, getDefValues().successfullyAddedLabel);
          } else {
            console.log("limitExceeded");
          }
        } else {
          //data = _IncData;
          console.log("ERROR")
          showError(toast, respCart.message);
        }
      }
      let storesInfo = getSyncStoresInfo();
      let loginInfo = getLoginInfo();
      if (loginInfo.userId) {
        try {
          if (curProducts.length > 0) {
            await callApiV2("frontend", "shopStatus", {
              customerid: loginInfo.userId,
              cartsessionid: data.id,
              storeid: storesInfo.selectedStoreId,
              data: JSON.stringify(data),
              page: "ADDPRODUCT",
            });
          }
        } catch (e) {
          console.log("no products" + e);
        }
      }

      /*********BLOOMREACH*********/
      let url = window.location.href;
      let urlObj = new URL(url);
      let pathParts = urlObj.pathname.split("/");
      pathParts.splice(pathParts.length - 1, 1);

      //console.log(pathParts);
      let fixedItems = [];
      let total_quantity = 0;
      for (let i in data.products) {
        let item = {
          item_id: data.products[i].productsku,
          quantity: data.products[i].quantity,
        };
        total_quantity += data.products[i].quantity;
        fixedItems.push(item);
      }
      var objBloomreach_CartUpdate = {
        action: "add",
        origen: "web",
        id_cart: data.id,
        item_id: _product.productsku,
        item_name: _product.label,
        item_price: _product.priceold,
        item_quantity: _quantity,
        items: fixedItems,
        total_quantity: total_quantity,
        total_price: data.subtotal,
      };
      if (pathParts[1]) {
        objBloomreach_CartUpdate["cat_espacios_level_1"] = pathParts[1];
      }
      if (pathParts[2]) {
        objBloomreach_CartUpdate["cat_espacios_level_2"] = pathParts[2];
      }
      if (pathParts[3]) {
        objBloomreach_CartUpdate["cat_espacios_level_3"] = pathParts[3];
      }
      //console.log("objBloomreach_CartUpdate", objBloomreach_CartUpdate);
      window.exponea.track("cart_update", objBloomreach_CartUpdate);

      /*********BLOOMREACH*********/

      //console.log("data final:", data);
      return data;
      /*
      setTimeout( function () {
        console.log("data TO",data)	
        return data
      }, 2500);
      */
    }
  } catch (Excep) {
    console.log("Ex", Excep);
    showError(toast, "SHOPCART Excep:" + Excep);
    return null;
  }
}

export function parseProductId(rawId) {
  const separators = ["_C_", "_S_"];
  for (const sep of separators) {
    if (String(rawId).includes(sep)) {
      const [productid, sku] = rawId.split(sep);
      return { productid: parseInt(productid), sku };
    }
  }
  return { productid: parseInt(rawId), sku: null };
}

export async function getS3PublicFile(url) {
  try {
    const response = await axios.get(url + `?t=${Date.now()}`, {});
    return response.data;
  } catch (err) {
    console.error("Error al obtener archivo público de S3:", err);
    return null;
  }
}

export function buildFlatSortedList(data) {
  return [...data]
    .filter(item => item.STATUSID !== 4)
    .sort((a, b) => {
      // Ordenar primero por nivel
      if (a.CATEGORYLEVEL !== b.CATEGORYLEVEL) {
        return a.CATEGORYLEVEL - b.CATEGORYLEVEL;
      }

      // Si el nivel es el mismo, ordenar alfabéticamente por label
      return a.CATEGORYLABEL.localeCompare(b.CATEGORYLABEL, "es", {
        sensitivity: "base",
      });
    });
}
